// A QR code's dark squares as one SVG path: the app's prints and the public invoice page draw it.
import qrcode from 'qrcode-generator'

// A payment QR may hold text beyond ASCII (a shop's name): the library's default
// keeps one byte per character and would redraw a different code.
qrcode.stringToBytes = (text: string) => [...new TextEncoder().encode(text)]

/** The dark squares of a QR code for `value`, as one SVG path over a `size`-module grid. */
export function qrPath(value: string): { size: number; path: string } {
  const qr = qrcode(0, 'M')
  qr.addData(value)
  qr.make()
  const size = qr.getModuleCount()
  let path = ''
  for (let row = 0; row < size; row++) {
    for (let col = 0; col < size; col++) {
      if (qr.isDark(row, col)) path += `M${col} ${row}h1v1h-1z`
    }
  }
  return { size, path }
}
